import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ButtonComponent, KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { CheckBoxDirective, KENDO_CHECKBOX, KENDO_INPUTS } from '@progress/kendo-angular-inputs';
import { LabelDirective } from '@progress/kendo-angular-label';
import { KENDO_PDFEXPORT } from '@progress/kendo-angular-pdf-export';
import { KENDO_PDFVIEWER } from '@progress/kendo-angular-pdfviewer';
import { PDFSERVICE } from '../../@theme/services/pdfgetfiles.service';
import { PDFViewerComponent } from '../pdfview.component';
@Component({
  selector: 'gd-getdisclosed',
  templateUrl: './disclosure-forms.component.html',
  styleUrls: ['./disclosure-forms.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CheckBoxDirective,
    KENDO_CHECKBOX,
    KENDO_INPUTS,
    KENDO_BUTTON,
    LabelDirective,
    ButtonComponent,
    KENDO_PDFVIEWER,
    KENDO_PDFEXPORT,
    PDFViewerComponent,
  ],
})
export class GetPDFDisclosureComponent implements OnInit {
  public disclosureSelectorForm: UntypedFormGroup
  public selectedFormData: Blob;
  public selectedFormDatashow: boolean;
  base64FromParent: string = '';
  public FilePath: any
  checkboxFields = [
    { name: 'ClientAccountAgreement', label: 'Client Account Agreement' },
    { name: 'cibNewAccount', label: 'Form CRS Acknowledgement & Account Activity Analysis (CIG & CIB) - formerly Client Transaction Analysis' },
    { name: 'cibretirmentInvestor', label: 'Retirement Investor Disclosure – CIG & CIB' },
    { name: 'cibAccountUpdate', label: 'Account Update Form - CIG & CIB' },
    { name: 'planDisclosure', label: '529 Plan Disclosure Agreement' },
    { name: 'disclosureAgreeBroker', label: 'Bank Disclosure Form - CIB' },
    { name: 'disclosureAgreeGroup', label: 'Bank Disclosure Form - CIG' },
    { name: 'capitalAccountUpdateForm', label: 'Capital Account Update Form' },
    { name: 'changeDealerCib', label: 'Change of Dealer' },
    { name: 'illiquidAssetIntervalFund', label: 'Illiquid Asset/Interval Fund Disclosure' },
    { name: 'illiquidAssetReitDisclosure', label: 'Illiquid Asset/REIT Disclosure' },
    { name: 'investmentSwitch', label: 'Investment Switch Disclosure Form' },
    { name: 'leadingQuestions', label: 'Leading Questions Form' },
    { name: 'letterOfAuthorization', label: 'LOA - Non-Qualified Acct Purchase' },
    { name: 'mutualFundClassB', label: 'Mutual Fund Class B Disclosure Agreement' },
    { name: 'mutualFundClassC', label: 'Mutual Fund Class C Disclosure Agreement' },
    { name: 'mutualFundSwitch', label: 'Mutual Fund Switch Disclosure Agreement' },
    { name: 'mutualFundMultipleFunds', label: 'Mutual Fund Multiple Funds Disclosure' },
    { name: 'oilAndGas', label: 'Oil & Gas Disclosure Agreement' },
    { name: 'retirementPlanRollover', label: 'Retirement Plan Rollover Disclosure' },
    { name: 'ticRealEstate', label: 'TIC Real Estate Disclosure Agreement' },
    { name: 'trustedContact', label: 'Trusted Contact Form' },
    { name: 'variableAnnuity', label: 'Variable Annuity Acknowledgment' },
    { name: 'variableAnnuityReplacement', label: 'Variable/Indexed Replacement Acknowledgment' }
  ];

  constructor(
    private pdfService: PDFSERVICE,
    private formBuilder: UntypedFormBuilder,
  ) {
    this.selectedFormDatashow = false;
  }

  ngOnInit(): void {
    this.disclosureSelectorForm = this.formBuilder.group({
      ClientAccountAgreement: false,
      CODblankfill: false,
      cibNewAccount: false,
      cibAccountUpdate: false,
      cibretirmentInvestor: false,
      planDisclosure: false,
      disclosureAgreeBroker: false,
      disclosureAgreeGroup: false,
      capitalAccountUpdateForm: false,
      changeDealerCib: false,
      changeDealerCig: false,
      illiquidAssetIntervalFund: false,
      illiquidAssetReitDisclosure: false,
      investmentSwitch: false,
      leadingQuestions: false,
      letterOfAuthorization: false,
      mutualFundClassB: false,
      mutualFundClassC: false,
      mutualFundSwitch: false,
      mutualFundMultipleFunds: false,
      oilAndGas: false,
      retirementPlanRollover: false,
      ticRealEstate: false,
      trustedContact: false,
      variableAnnuity: false,
      variableAnnuityReplacement: false,
    })
  }
  onSubmit(event) {
    this.selectedFormDatashow = false;
    const requestedForms = []
    for (const field in this.disclosureSelectorForm.controls) {
      const control = this.disclosureSelectorForm.get(field)
      if (control.value) {
        requestedForms.push(field)
      }
    }
    this.FilePath = requestedForms
    this.pdfService
      .getPdfDisclosureForms(requestedForms)
      .subscribe((response) => {
        this.selectedFormDatashow = true;
        this.selectedFormData = response

      })
  }
}